import { useCamerasStore } from '@/store/cameras.js'
import { useCameraName } from '@/composables/cameraHelpers.ts'
import DimensionResolver from '@/composables/charts/influx-charts/dimension-resolvers/DimensionResolver.js'
import { useInstanceStore } from '@/store/backendInstances.js'
import { isArray } from 'lodash'

/**
 * Dimension Resolver for Cameras.
 * Matches on the tag key "camera", and resolved the expected cameraIds to the respective camera names.
 */
class CameraDimensionResolver extends DimensionResolver {
  async prepareResolver() {
    if (this.prepared) return
    this.reloadedOnce = false
    await super.prepareResolver()
    const cameraStore = useCamerasStore()
    await cameraStore.ensureCamerasLoaded()
  }

  async doesTagKeyMatch(tag, dataPoint, query = undefined) {
    if (tag === 'camera') return true
    if (query?.path.endsWith('/regionSums')) {
      if (isArray(query.query)) {
        for (const queryElement of query.query) {
          if (queryElement.where.property === 'camera') return true
        }
      } else {
        if (query.query.where.property === 'camera') return true
      }
    }
    return false
  }

  async humanizeTagValue(tagValue) {
    const camera = useCamerasStore().getCameraById(undefined, tagValue)
    if (!camera && !this.reloadedOnce) {
      this.reloadedOnce = true
      await useCamerasStore().loadCameras()
    }
    return useCameraName(tagValue)
  }
  static isRelevantForCurrentInstance() {
    return useInstanceStore().selectedInstance.instanceType === 'barn'
  }
}

export default CameraDimensionResolver
